import { useState } from 'react'

import ButtonsAndQuickFilters from './ButtonsAndQuickFilters'
import FilterDrawer from './FilterDrawer'
import { PERIOD_OPTIONS } from './PeriodFilter'
import { PLAYED_OPTIONS } from './PlayedFilter'

export type ShiurimFilters = {
  played?: { option: PLAYED_OPTIONS; value: boolean }
  period?: { option: PERIOD_OPTIONS; startDate: Date; endDate: Date }
  series?: { title: string; id: string }[]
  topics?: { title: string; id: string }[]
  subtopics?: { title: string; id: string }[]
}

type Props = {
  filters: ShiurimFilters
  noTopics?: boolean
  noSeries?: boolean
  topicId?: string
  withQuickFilters?: boolean
  onChangeFilters?: (filters: ShiurimFilters) => void
  seriesId?: string
  seriesCount?: number
  onMarkedAsRead?: () => void
}

function ShiurimFilter({
  filters,
  noTopics,
  noSeries,
  withQuickFilters,
  onChangeFilters,
  seriesId,
  seriesCount,
  onMarkedAsRead,
}: Props) {
  const [newFilters, setNewFilters] = useState(filters)
  const [open, setOpen] = useState(false)

  const onOpen = () => {
    setOpen(true)
  }

  const onClose = () => {
    setOpen(false)
  }

  const onApply = () => {
    onChangeFilters(newFilters)

    onClose()
  }

  const onReset = () => {
    onChangeFilters({})
    setNewFilters({})

    onClose()
  }

  const onResetOne = (filterName: keyof ShiurimFilters) => {
    const updatedFilter = { ...filters }
    delete updatedFilter[filterName]

    onChangeFilters(updatedFilter)
    setNewFilters(updatedFilter)
  }

  const filterCount = Object.values(filters).filter((el) => {
    if (Array.isArray(el)) {
      return el.length > 0
    }
    return !!el
  }).length

  return (
    <>
      <ButtonsAndQuickFilters
        filters={filters}
        newFilters={newFilters}
        filtersCount={filterCount}
        withQuickFilters={withQuickFilters}
        noTopics={noTopics}
        noSeries={noSeries}
        onOpen={onOpen}
        onResetOne={onResetOne}
        onReset={onReset}
        onApply={onApply}
        onChangeFilters={setNewFilters}
      />
      <FilterDrawer
        filters={newFilters}
        noTopics={noTopics}
        noSeries={noSeries}
        open={open}
        onClose={onClose}
        onReset={onReset}
        onApply={onApply}
        onChangeFilters={setNewFilters}
        seriesId={seriesId}
        seriesCount={seriesCount}
        onMarkedAsRead={onMarkedAsRead}
      />
    </>
  )
}

export default ShiurimFilter
